module.exports = __webpack_public_path__ + "static/media/PICCO Logo.68ce31d8.png";